<app-generic-map
  *ngIf="mapSettings"
  [namespaces]="namespacesChange"
  [mapSettings]="mapSettings"
  [mapFrontendSettings]="mapFrontendSettings"
  (timeStepChange)="onTimeStepChange($event)"
  (layersVisibilityChange)="onLayersVisibilityChange($event)"
>
</app-generic-map>
